export function formatPrice(price: number | string): string {
  return Number(price).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Format cents (hundredths of EUR) to price string
 * @param cents - Amount in cents (e.g., 149000 = 1490.00 EUR)
 * @returns Formatted price string (e.g., "1490,00")
 */
export function formatCents(cents: number): string {
  return (
    new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format((cents || 0) / 100) + " €"
  );
}
